import {LoadingOutlined} from '@ant-design/icons';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {compose} from 'redux';
import * as Yup from 'yup';
import {get, patch, put} from '../../../../api/api';
import {
  uriGetInsuranceInYourHandsCheckboxValue,
  uriGetThirdPartyAuthorizedUsers,
  uriPatchThirdPartyAuthorizedUsers,
  uriUpdateInsuranceInYourHandsCheckboxValue,
} from '../../../../api/endpoints';
import AppButton from '../../../../components/app-button/index';
import AppParagraph from '../../../../components/app-paragraph/index';
import {AppForm} from '../../../../components/forms';
import AppFormCheckboxField from '../../../../components/forms/AppFormCheckboxField';
import Header2 from '../../../../components/headers/header2/Header2';
import Icon from '../../../../components/icon';
import {Column, Row} from '../../../../components/layout';
import ModalTemplate from '../../../../components/modal/index';
import {addToWizard, setWizard} from '../../../../store/actions';
import colors from '../../../../util/colors';
import * as fonts from '../../../../util/fonts';
import {Icons} from '../../../../util/icons';
import {strings} from '../../../../util/strings';
import {
  bulletLabelsParagraphs,
  getUserMemId,
  labelsParagraphs,
} from '../../../../util/utility';
import ErrorPopup from '../../error-popup/ErrorPopup';
import SelectUsersPopup from './select-users-popup/SelectUsersPopup';
import './styles.scss';

interface MyInsuranceTabProps {
  user: any;
  titular: any;
  selectedBu: any;
  availableBus: any[];
  wizard: any;
  buStyles: any;
  setWizard(value: any): void;
  addToWizard(value: any): void;
  labels: typeof strings.pt.login;
  labelsPermissions: typeof strings.pt.permissions;
  oneTrust: typeof strings.pt.oneTrust;
  purposes: any;
}

const validationSchema = Yup.object().shape({
  termsAccepted: Yup.boolean().required(),
  privacyPolicyAccepted: Yup.boolean().required(),
});

function MyInsuranceTab({
  user,
  selectedBu,
  availableBus,
  labels,
  labelsPermissions,
  wizard,
  buStyles,
  titular,
  setWizard,
  purposes,
  addToWizard,
  oneTrust,
}: MyInsuranceTabProps) {
  const [insuranceInYourHands, setInsuranceInYourHands] = useState(false);

  const [thirdPartiesAuthorization, setThirdPartiesAuthorization] =
    useState(false);
  const [thirdPartiesAuthorized, setThirdPartiesAuthorized] = useState(false);
  const [showSelectModal, setShowSelectModal] = useState(false);

  const [loadingPermissions, setLoadingPermissions] = useState(false);
  const [memId, setMemId] = useState('');
  const [showError, setShowError] = useState(false);
  const [showMoreInfo, setShowMoreInfo] = useState(false);

  const [overEighteenUsers, setOverEighteenUsers]: any[] = useState([]);
  const [initialSelectedUsers, setInitialSelectedUsers]: any[] = useState([]);

  const [newestDate, setnewestDate] = useState('');
  const [showThirdParties, setShowThirdParties] = useState(false);
  const [showInsuranceInYourHands, setShowInsuranceInYourHands] =
    useState(false);

  const featureName = 'MyInsurance';

  labelsParagraphs(labels);
  bulletLabelsParagraphs(labelsPermissions);

  const refresh = () => {
    window.location.reload();
  };

  const dateToString = (date: any, lang = 'pt') => {
    let string = moment(date).locale(lang).format('L');
    string = string.replace(/(\/)/g, '.');
    return string;
  };

  useEffect(() => {
    setLoadingPermissions(true);
    const loggedInsurancePerson = getUserMemId(availableBus, user, selectedBu);
    setMemId(loggedInsurancePerson.memId);
    setInitialValues(loggedInsurancePerson.memId);
  }, [selectedBu.memId]);

  const findAge = (dob: any) => {
    var age = moment().diff(dob, 'years');
    return age;
  };

  const setInitialValues = async (memId: any) => {
    //setMemId(getUserMemId());
    if (!memId) {
      setShowThirdParties(false);
      setShowInsuranceInYourHands(false);
    } else {
      try {
        const result: any = await get(
          uriGetInsuranceInYourHandsCheckboxValue(selectedBu.buId, memId),
          false,
          0,
          featureName
        );
        if (result?.data?.items[0]?.property === '0') {
          setInsuranceInYourHands(true);
        } else {
          setInsuranceInYourHands(false);
        }
      } catch (e: any) {}

      try {
        let response: any = await get(
          uriGetThirdPartyAuthorizedUsers(selectedBu.buId, memId),
          false,
          0,
          featureName
        );
        let aux: any[] = [];
        let selectedAux: any[] = [];
        let checkboxFlag = false;
        if (response.data?.items?.length === 0) {
          setShowThirdParties(false);
        } else if (
          response.data?.items?.every((e: any) => {
            return findAge(e.dob) < 18;
          })
        ) {
          setShowThirdParties(false);
        } else {
          response.data?.items?.forEach((e: any) => {
            if (findAge(e.dob) >= 18) {
              setShowThirdParties(true);
              aux.push({label: e.name, value: e.memId});
              if (e.authorized === true) {
                checkboxFlag = true;
                setThirdPartiesAuthorization(true);
                setThirdPartiesAuthorized(true);
                selectedAux.push(e.name);
                if (newestDate === '') {
                  setnewestDate(e.beginDate);
                } else if (findAge(e.beginDate) < findAge(newestDate)) {
                  setnewestDate(e.beginDate);
                }
              }
            }
          });
        }
        if (!checkboxFlag) {
          setThirdPartiesAuthorization(false);
          setThirdPartiesAuthorized(false);
        }
        setOverEighteenUsers(aux);
        setInitialSelectedUsers(selectedAux);
      } catch (e: any) {
        setShowThirdParties(false);
      }

      if (
        labelsPermissions?.permissions_myinsurance_checkbox_insuranceinyourhands ===
        '1'
      )
        setShowInsuranceInYourHands(true);
    }

    if (
      labelsPermissions?.permissions_myinsurance_checkbox_insuranceinyourhands ===
      '0'
    )
      setShowInsuranceInYourHands(false);

    if (
      labelsPermissions?.permissions_myinsurance_checkbox_thirdpartypermissions ===
      '0'
    )
      setShowThirdParties(false);

    setLoadingPermissions(false);
  };

  const insuranceInYourHandsChange = async () => {
    try {
      if (insuranceInYourHands) {
        setInsuranceInYourHands(false);
        await put(
          uriUpdateInsuranceInYourHandsCheckboxValue(),
          {
            buId: selectedBu.buId,
            memId: memId,
            propValue: false,
          },
          featureName
        ).then((response: any) => {
          if (response?.result?.status !== 'Success') {
            setShowError(true);
          }
        });
      } else {
        setInsuranceInYourHands(true);
        await put(
          uriUpdateInsuranceInYourHandsCheckboxValue(),
          {
            buId: selectedBu.buId,
            memId: memId,
            propValue: true,
          },
          featureName
        ).then((response: any) => {
          if (response?.result?.status !== 'Success') {
            setShowError(true);
          }
        });
      }
    } catch (e: any) {
      if (e.status != 200 || e.status != 202) {
        setShowError(true);
      }
    }
  };

  const submitThirdPartiesAuthorization = async (selectedItems: any[]) => {
    let bodyPermissions: any = [];
    overEighteenUsers.forEach((e: any) => {
      if (selectedItems.find((aux: any) => e.label === aux)) {
        bodyPermissions.push({memId: e.value, authorized: true});
      } else {
        bodyPermissions.push({memId: e.value, authorized: false});
      }
    });
    try {
      await patch(
        uriPatchThirdPartyAuthorizedUsers(),
        {
          buId: selectedBu.buId,
          memId: memId,
          permissions: bodyPermissions,
        },
        featureName
      );
    } catch (e: any) {
      setShowError(true);
    } finally {
      setInitialValues(memId);
    }
  };

  const renderTextWithBulletPoints = (text: string) => {
    const parts = text?.split(':');

    return (
      <>
        {parts[0]}:
        {parts[1]?.split(';').map((item: string, index: number) => {
          return (
            <React.Fragment key={index}>
              {index !== 0 && item && `${item};`}
              <p></p>
            </React.Fragment>
          );
        })}
      </>
    );
  };

  const onClose: any = () => {
    setShowSelectModal(false);
    setInitialValues(memId);
  };

  const notAllowedComponent = () => {
    return (
      <Column className="permissions-not-allowed">
        <Icon
          className="reimbursement-no-results-history-filter-icon"
          name={Icons.ALERT_PROBLEM}
          color={colors.lightGrey}
          width="40"
          height="40"
          changeViewbox
          viewBox={'0 0 24 24'}
        />
        <h6
          className="reimbursement-list-header"
          style={{color: colors.lightGrey, fontFamily: 'Poppins'}}>
          {labelsPermissions?.permissions_not_allowed_to_manage}
        </h6>
      </Column>
    );
  };

  return (
    <div>
      <Row className="tab-panel-row">
        <div className="permissions-tab-panel">
          <AppForm
            className="communications-form-container"
            initialValues={{}}
            validationSchema={validationSchema}
            onSubmit={async (values) => {}}>
            {loadingPermissions ? (
              <></>
            ) : (
              showInsuranceInYourHands && (
                <>
                  <Row>
                    <p style={{...fonts.ML}} className="meu-seguro-title-row">
                      {labelsPermissions.permissions_subtitleInsuranceOnHand}
                    </p>
                  </Row>
                  <Row className="meu-seguro-description">
                    <label
                      style={{...fonts.SM, ...fonts.Medium}}
                      className="align-left-label">
                      <AppParagraph
                        label={
                          labelsPermissions.permissions_descriptionInsuranceOnHand
                        }
                      />{' '}
                      <Link
                        className="communications-anchor"
                        style={{color: buStyles.primaryColor}}
                        to="#"
                        onClick={() => setShowMoreInfo(true)}>
                        {
                          labelsPermissions.permissions_clickOnHereInsuranceOnHand
                        }
                      </Link>
                    </label>
                  </Row>
                  <Row className="meu-seguro-checkbox-row">
                    <AppFormCheckboxField
                      showErrorMessage
                      purposeId={oneTrust.purposeMarketingComunications}
                      name="marketingCommunication"
                      className="meu-seguro-checkbox"
                      labelClass="checkbox-input-labelclass"
                      value={insuranceInYourHands}
                      onChange={() => insuranceInYourHandsChange()}
                      label={
                        <label
                          style={{...fonts.SM, ...fonts.Medium}}
                          className="agree-checkbox">
                          {labelsPermissions.permissions_agreeInsuranceOnHand}
                        </label>
                      }
                    />
                  </Row>
                </>
              )
            )}
            <ModalTemplate
              className="moreinfo-modal"
              show={showMoreInfo}
              onHide={() => setShowMoreInfo(false)}
              hideFooter={true}
              cross={true}>
              <Row>
                <Header2
                  style={{...fonts.Bold, ...fonts.XL, color: colors.black}}
                  className="moreinfo-modal-header">
                  {labels?.insurance_moreInfo}
                </Header2>
              </Row>
              <Column
                style={{textAlign: 'initial'}}
                className="moreinfo-modal-info">
                <AppParagraph label={labels?.insurance_moreInfoDescription} />
              </Column>
              <Row className="moreinfo-modal-button">
                <AppButton
                  variant="secondary"
                  onClick={() => setShowMoreInfo(false)}>
                  {labels?.insurance_moreInfoButton}
                </AppButton>
              </Row>
            </ModalTemplate>
            {loadingPermissions ? (
              <LoadingOutlined style={{fontSize: 24, marginTop: '50px'}} spin />
            ) : (
              showThirdParties && (
                <>
                  <Row className="meu-seguro-title-row">
                    <p style={{...fonts.ML}}>
                      {
                        labelsPermissions.permissions_subtitleAuthorizationThirdParties
                      }
                    </p>
                  </Row>
                  <Row className="meu-seguro-checkbox-row">
                    <AppFormCheckboxField
                      showErrorMessage
                      purposeId={oneTrust.purposeHealthPrevention}
                      name="autorizacaoterceiros"
                      className="communications-checkbox"
                      onChange={() => {
                        setShowSelectModal(true);
                        setThirdPartiesAuthorization(
                          !thirdPartiesAuthorization
                        );
                      }}
                      value={thirdPartiesAuthorization}
                      label={
                        <label
                          style={{...fonts.SM, ...fonts.Medium}}
                          className="align-left-label-3-party">
                          {
                            labelsPermissions.permissions_descriptionAuthorizationThirdParties1
                          }{' '}
                          <a
                            className="communications-anchor"
                            style={{color: buStyles.primaryColor}}
                            onClick={() => setShowSelectModal(true)}>
                            {
                              labelsPermissions.permissions_clickOnAuthorizationThirdParties
                            }
                          </a>{' '}
                          <AppParagraph
                            noParagraph
                            label={
                              labelsPermissions?.permissions_descriptionAuthorizationThirdParties2
                            }
                          />
                        </label>
                      }
                    />
                    <ErrorPopup
                      show={showError}
                      setShowModal={setShowError}
                      refresh={refresh}
                    />
                  </Row>
                  <Row className="thirdParties-authorized-row">
                    {thirdPartiesAuthorized && (
                      <p style={{...fonts.SM, ...fonts.Bold}}>
                        {labelsPermissions.permissions_allowed}{' '}
                        {dateToString(newestDate)}{' '}
                        {labelsPermissions.permissions_where}{' '}
                        {labelsPermissions.permissions_myAdv}
                      </p>
                    )}
                  </Row>
                </>
              )
            )}
            {!loadingPermissions &&
              !showInsuranceInYourHands &&
              !showThirdParties &&
              (labelsPermissions?.permissions_myinsurance_checkbox_insuranceinyourhands ===
                '1' ||
                labelsPermissions?.permissions_myinsurance_checkbox_thirdpartypermissions ===
                  '1') &&
              notAllowedComponent()}
          </AppForm>
          <SelectUsersPopup
            overEighteen={overEighteenUsers}
            onClose={onClose}
            initialSelectedUsers={initialSelectedUsers}
            show={showSelectModal}
            setShowModal={setShowSelectModal}
            onSubmit={(selectedItems) =>
              submitThirdPartiesAuthorization(selectedItems)
            }
          />
        </div>
      </Row>
    </div>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  wizard,
  availableBus,
  globalStyles,
  titular,
  purposes,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  availableBus: availableBus.value,
  labels: strings.value.pt.login,
  labelsPermissions: strings.value.pt.permissions,
  oneTrust: strings.value.pt.oneTrust,
  wizard: wizard.value,
  buStyles: globalStyles.value,
  titular: titular.value,
  purposes: purposes.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(MyInsuranceTab)
);
